import { normalizePath } from './normalizePath';

export interface PlayCountEntry {
  playCount: number;
  artist?: string;
  title?: string;
}

export type PlayCountMap = Record<string, PlayCountEntry>;

export const mergePlayCounts = (
  ...maps: (PlayCountMap | undefined)[]
): PlayCountMap => {
  const merged: PlayCountMap = {};

  maps.forEach((map) => {
    if (!map) return;

    Object.entries(map).forEach(([path, entry]) => {
      const normalizedPath = normalizePath(path).toLowerCase();

      if (merged[normalizedPath]) {
        merged[normalizedPath].playCount += entry.playCount;
        if (!merged[normalizedPath].artist && entry.artist) {
          merged[normalizedPath].artist = entry.artist;
        }
        if (!merged[normalizedPath].title && entry.title) {
          merged[normalizedPath].title = entry.title;
        }
      } else {
        merged[normalizedPath] = { ...entry };
      }
    });
  });

  return merged;
};
